<div class="side-nav-list">
  <btx-side-nav-link *ngFor="let navItem of navItems"
                     [item]="navItem">
  </btx-side-nav-link>
</div>
